import { FLIPPER_KEYS } from '~/store/flippers/const'
import { FlipperResponseMap } from './types'

export const FLIPPER_RESPONSE_MAP: Partial<FlipperResponseMap> = {
  [FLIPPER_KEYS.STRAITSX_APP_DASHBOARD_USE_EARN]: 'isEarnEnabled',
} as const
